
import React from "react";
import _ from "lodash";
import autoBind from "react-autobind";
import DragScroll from "react-indiana-drag-scroll";
import { isMobileBrowser } from "../../utils/utils";

class DraggableScrollContainer extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
	}

	render() {

		let container;
		const { listScrollContainerRef } = this.props;

		if (isMobileBrowser()) {			
			let style = _.clone(this.props.style);
			style.overflowX = "auto";

			container = <div ref={listScrollContainerRef} id="list-scroll-container" style={style}>
				{this.props.children}
			</div>;	
		} else {
			container = <DragScroll ref={listScrollContainerRef} id="list-scroll-container" style={this.props.style}>
				{this.props.children}
			</DragScroll>;
		}

		return container;
	}	
}

export default DraggableScrollContainer;
